<script setup lang="ts">
import IntInput from '@components/form/int-input.vue';
import {
    ModelValueEmitsType, ModelValuePropsInterface,
    useModelValueComposable,
} from '@components/form/compsables/model-value-composable.js';
import {
    FormPartEmitsType,
    FormPartProps,
    useFormPartComposable,
} from '@src/form/composables/form-part-composable.js';
import HorizontalAlignChildrenWrapper from '@components/layout-wrapper/horizontal-align-children-wrapper.vue';
import SelectOneBinWarehouse from '@src/bin/component/select-one-bin-warehouse.vue';
import { Bin } from '@src/warehouse/interfaces/bin.ts';
import apiClient from '@src/api/api-client.ts';
import { ref, watch } from 'vue';
import VerticalAlignChildrenWrapper from '@components/layout-wrapper/vertical-align-children-wrapper.vue';
import FormError from '@components/form/input-base-components/form-error.vue';

defineProps<ModelValuePropsInterface<number|null> & FormPartProps & {
    submitButton?: string,
    oneBinWarehouseSelection?: boolean,
    hideLabel?: boolean
}>();

const emit = defineEmits<ModelValueEmitsType & FormPartEmitsType & ((event: 'select', selectedBin: Bin) => void)>();

const { modelValue, exposes: modelValueExposes } = useModelValueComposable<number|null>();
const { submit, exposes: formPartExposes, validationMessage } = useFormPartComposable(modelValue);

function oneBinWarehouseSelected(bin: Bin|null) {
    modelValue.value = bin?.idBin ?? null;
    submit();
}

const bin = ref<Bin|null>(null);

watch(modelValue, async () => {
    if (!modelValue.value) {
        return;
    }

    bin.value = (await apiClient.get('/be/warehouse/bin/' + modelValue.value)).data;
});

watch(bin, () => {
    if (bin.value === null) {
        return;
    }
    emit('select', bin.value);
});

defineExpose({
    ...modelValueExposes,
    ...formPartExposes,
});
</script>

<template>
    <VerticalAlignChildrenWrapper>
        <HorizontalAlignChildrenWrapper gap="3" gap-on-small-screen="0">
            <IntInput
                v-model="modelValue"
                :submit-button="submitButton"
                :label="hideLabel ? false : 'Lagerfach eingeben'"
                large
                autofocus
                @submit="submit"
            />
            <SelectOneBinWarehouse
                v-if="oneBinWarehouseSelection"
                :label="hideLabel ? false : undefined"
                :model-value="bin"
                @update:model-value="oneBinWarehouseSelected"
            />
        </HorizontalAlignChildrenWrapper>
        <FormError v-if="validationMessage" :message="validationMessage"/>
    </VerticalAlignChildrenWrapper>
</template>
